export default __webpack_public_path__ + "static/char-40-fd85c62f27d4479698bd427d758de530.gif";